export enum UploadErrors {
  DELETE = 'uploads/deleteUpload',
  CREATE = 'uploads/createUpload',
  GET = 'uploads/getUpload',
  UPDATE = 'uploads/updateUpload'
}
